import { ProductionPriceConditionPrice } from 'src/state/production-price-list/state-models/production-price-condition-price';
import { ComponentType } from 'src/state/master-data/state-models/component-type';

export interface ComponentTypeProductionValue {
    id: number;
    componentType: ComponentType;
    productionPriceConditionPrice: ProductionPriceConditionPrice;
    isUniqueDesign : boolean;
}
